import { useEffect, useState } from 'react';
import { GeneralSetupDataType } from './AlertStatusSetupContext';

const useGeneralSetupData = (initialGeneralSetupData: GeneralSetupDataType) => {
  const [generalSetupData, setGeneralSetupData] = useState(initialGeneralSetupData);

  useEffect(() => {
    setGeneralSetupData(initialGeneralSetupData);
  }, [initialGeneralSetupData]);

  const [isGeneralSetupValid, setGeneralSetupValid] = useState(true);
  const [isGeneralSetupSubmissionTouched, setGeneralSetupSubmissionTouched] = useState(false);
  const [isGeneralSetupSubmitted, setGeneralSetupSubmitted] = useState(false);

  return {
    generalSetupData,
    setGeneralSetupData,
    isGeneralSetupValid,
    setGeneralSetupValid,
    isGeneralSetupSubmissionTouched,
    setGeneralSetupSubmissionTouched,
    isGeneralSetupSubmitted,
    setGeneralSetupSubmitted,
  };
};

export default useGeneralSetupData;
